(function () {
  let vimeoAPIReady = false;

  function loadVimeoAPI() {
    if (window.Vimeo) {
      vimeoAPIReady = true;
      return;
    }
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.onload = () => {
      vimeoAPIReady = true;
    };
    document.head.appendChild(script);
  }

  window.addEventListener("message", function (event) {
    if (!event.data || typeof event.data !== "string") return;

    try {
      const data = JSON.parse(event.data);

      if (data.event === "infoDelivery" && data.info) {
        handleYouTubeStateChange(data.info);
      }
    } catch (e) {}
  });

  function handleYouTubeStateChange(info) {
    if (!info.playerState && info.playerState !== 0) return;

    const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');

    iframes.forEach((iframe) => {
      const mediaId = iframe.dataset.mediaId;
      if (!mediaId) return;

      const btn = document.querySelector(`.js-video-play-block[data-media-id="${mediaId}"]`);
      if (!btn) return;

      if (info.playerState === 1) {
        btn.dataset.state = "playing";
        updateButtonAppearance(btn, "playing");
      } else if (info.playerState === 2 || info.playerState === 0) {
        btn.dataset.state = "paused";
        updateButtonAppearance(btn, "paused");
      }
    });
  }

  function updateButtonAppearance(btn, state) {
    const iconWrapper = btn.querySelector(".svg-wrapper");
    const labelSpan = btn.querySelector("span:not(.svg-wrapper)");

    if (state === "playing") {
      btn.classList.add("playing");
      if (iconWrapper) {
        iconWrapper.innerHTML = `
          <svg viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        `;
      }
      if (labelSpan && labelSpan.textContent.toLowerCase().includes("play")) {
        labelSpan.textContent = labelSpan.textContent.replace(/play/i, "Pause");
      }
    } else {
      btn.classList.remove("playing");
      if (iconWrapper) {
        iconWrapper.innerHTML =
          iconWrapper.dataset.originalIcon ||
          `<svg viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
            <polygon points="5,3 19,12 5,21"></polygon>
          </svg>`;
      }
      if (labelSpan && labelSpan.textContent.toLowerCase().includes("pause")) {
        labelSpan.textContent = labelSpan.textContent.replace(/pause/i, "Play");
      }
    }
  }

  function storeOriginalIcons() {
    document.querySelectorAll(".js-video-play-block .svg-wrapper").forEach((wrapper) => {
      if (!wrapper.dataset.originalIcon) {
        wrapper.dataset.originalIcon = wrapper.innerHTML;
      }
    });
  }

  function enableYouTubeInfoUpdates(iframe) {
    if (!iframe.src.includes("enablejsapi=1")) {
      const separator = iframe.src.includes("?") ? "&" : "?";
      iframe.src += `${separator}enablejsapi=1`;
    }

    setTimeout(() => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "listening",
          id: iframe.id || "player",
          channel: "widget",
        }),
        "*",
      );
    }, 100);
  }

  function handlePlayButtonClick(e) {
    const btn = e.target.closest(".js-video-play-block");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.processing === "true") return;
    btn.dataset.processing = "true";

    const mediaId = btn.dataset.mediaId;
    if (!mediaId) {
      btn.dataset.processing = "false";
      return;
    }

    const deferred = document.querySelector(`deferred-video[data-media-id="${mediaId}"]`);

    if (deferred && !deferred.hasAttribute("loaded")) {
      deferred.loadContent(true);
      btn.dataset.processing = "false";
      return;
    }

    handleVideoToggle(btn, mediaId);
    setTimeout(() => {
      btn.dataset.processing = "false";
    }, 300);
  }

  function handleVideoToggle(btn, mediaId) {
    const selectors = [
      `video[data-media-id="${mediaId}"]`,
      `iframe[data-media-id="${mediaId}"]`,
      `#Banner-${mediaId} video`,
      `#Banner-${mediaId} iframe`,
      `.banner video`,
      `.banner iframe`,
      `[data-video-id="${mediaId}"] video`,
      `[data-video-id="${mediaId}"] iframe`,
    ];

    let videoEl = null;
    for (const selector of selectors) {
      videoEl = document.querySelector(selector);
      if (videoEl) break;
    }

    if (!videoEl) {
      console.warn("Video element not found for media ID:", mediaId);
      return;
    }

    const currentState = btn.dataset.state || "paused";

    if (videoEl.tagName === "VIDEO") {
      handleNativeVideo(videoEl, btn);
    } else if (videoEl.tagName === "IFRAME") {
      if (videoEl.src.includes("youtube.com") || videoEl.src.includes("youtu.be")) {
        handleYouTubeVideo(videoEl, btn, currentState);
      } else if (videoEl.src.includes("vimeo.com")) {
        handleVimeoVideo(videoEl, btn, currentState);
      }
    }
  }

  function handleNativeVideo(videoEl, btn) {
    if (!videoEl.dataset.bound) {
      videoEl.addEventListener("play", () => {
        btn.dataset.state = "playing";
        updateButtonAppearance(btn, "playing");
      });

      videoEl.addEventListener("pause", () => {
        btn.dataset.state = "paused";
        updateButtonAppearance(btn, "paused");
      });

      videoEl.addEventListener("ended", () => {
        btn.dataset.state = "paused";
        updateButtonAppearance(btn, "paused");
      });

      videoEl.dataset.bound = "true";
    }

    if (videoEl.paused) {
      videoEl.play().catch((err) => {
        console.error("Error playing video:", err);
      });
    } else {
      videoEl.pause();
    }
  }

  function handleYouTubeVideo(videoEl, btn, currentState) {
    if (!videoEl.dataset.youtubeReady) {
      enableYouTubeInfoUpdates(videoEl);
      videoEl.dataset.youtubeReady = "true";
    }

    if (currentState === "paused") {
      videoEl.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "playVideo",
          args: "",
        }),
        "*",
      );

      btn.dataset.state = "playing";
      updateButtonAppearance(btn, "playing");
    } else {
      videoEl.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: "",
        }),
        "*",
      );

      btn.dataset.state = "paused";
      updateButtonAppearance(btn, "paused");
    }
  }

  function handleVimeoVideo(videoEl, btn, currentState) {
    if (currentState === "paused") {
      videoEl.contentWindow.postMessage('{"method":"play"}', "*");
      btn.dataset.state = "playing";
      updateButtonAppearance(btn, "playing");
    } else {
      videoEl.contentWindow.postMessage('{"method":"pause"}', "*");
      btn.dataset.state = "paused";
      updateButtonAppearance(btn, "paused");
    }
  }

  function observeNewIframes() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === "IFRAME" && (node.src.includes("youtube.com") || node.src.includes("youtu.be"))) {
            enableYouTubeInfoUpdates(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    storeOriginalIcons();

    document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]').forEach((iframe) => {
      enableYouTubeInfoUpdates(iframe);
    });

    if (document.querySelector('iframe[src*="vimeo.com"]')) {
      loadVimeoAPI();
    }

    document.addEventListener("click", handlePlayButtonClick);
    observeNewIframes();

    if (!document.querySelector("#video-button-styles")) {
      const style = document.createElement("style");
      style.id = "video-button-styles";
      style.textContent = `
        .js-video-play-block.playing {
          background-color: rgba(255, 255, 255, 0.4) !important;
        }
        .js-video-play-block svg {
          transition: all 0.2s ease;
        }
      `;
      document.head.appendChild(style);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.updateButtonAppearance = updateButtonAppearance;
  window.enableYouTubeInfoUpdates = enableYouTubeInfoUpdates;
})();
